import React from "react";
import { providePriceForExtraOffer } from "../../../../server/sharedScripts/priceProviderInterpreter.js";
import OrderedImageRow from "../orderedImageRow/orderedImageRow.js";
import "./orderedImagesList.css";
export default function OrderedImagesList(props) {
    var _a, _b;
    const areResources = props.order.orders.some((order) => order.selectedCustomization);
    return (React.createElement("section", { className: "ordered-images-list-container section" },
        React.createElement("table", { className: "ordered-images-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Zdj\u0119cie"),
                    React.createElement("th", null, "Typ zam\u00F3wienia"),
                    areResources && React.createElement("th", null, "Wybrany zas\u00F3b"),
                    React.createElement("th", null, "Formaty"),
                    React.createElement("th", null, "Kwota"))),
            React.createElement("tbody", null, props.order.orders.map((order, index) => (React.createElement(OrderedImageRow, { areResources: areResources, key: index, order: order, orders: props.order.orders }))))),
        ((_a = props.order.oneTimeOrders) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(React.Fragment, null,
            React.createElement("br", null),
            React.createElement("h3", null, "Zam\u00F3wienia ofert jednorazowych"),
            React.createElement("table", { className: "ordered-images-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Oferta"),
                        React.createElement("th", null, "Pole tekstowe klienta"),
                        React.createElement("th", null, "Sztuk"),
                        React.createElement("th", null, "Kwota"))),
                React.createElement("tbody", null, (_b = props.order.oneTimeOrders) === null || _b === void 0 ? void 0 : _b.map((order, index) => {
                    var _a, _b;
                    return (React.createElement("tr", { key: index },
                        React.createElement("td", null, order.offerName),
                        React.createElement("td", null, (_a = order.textInputContent) !== null && _a !== void 0 ? _a : "nie dotyczy"),
                        React.createElement("td", null, (_b = order.count) !== null && _b !== void 0 ? _b : 1),
                        React.createElement("td", null,
                            providePriceForExtraOffer(order),
                            " z\u0142")));
                })))))));
}
